import ko from 'knockout';

window.ko = ko;